import { Injectable } from 'angular-ts-decorators';

import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { Domain } from '@shared/app/scripts/services/domain';
import type { IConfig } from '@shared/app/scripts/services/config';
import type { IStandardErrorParser } from '@shared/app/scripts/services/standard-error-parser';

/**
 * Factory in the sharedModule. It takes care of communication with customer
 * resource. Methods are inherited form {@link shared.spynlBase
 * spynlBase} service, and are documented there.
 *
 * # Data schema
 * {@link http://docs.dev.swcloud.nl/schemas/bower_components/docson/#../../spynl/customer.json
 * is documented with json-schema}
 */
@Injectable('customer')
export class Customer extends SpynlBase<Object> {
  protected location: string;
  constructor(
    $http: ng.IHttpService,
    $q: ng.IQService,
    sentry,
    domain: Domain,
    standardErrorParser: IStandardErrorParser,
    config: IConfig,
  ) {
    'ngInject';

    super($http, $q, sentry, domain, config, standardErrorParser, Object);
    this.location = '/customers';
  }
}
